import React from 'react';

const ServiceStats = () => {
  const stats = [
    { label: 'Total Servers Tested', value: '42,853', subtext: '+254 this week', subtextColor: 'text-accent-green' },
    { label: 'Vulnerabilities Found', value: '8,741', subtext: 'Critical: 1,245', subtextColor: 'text-accent-red' },
    { label: 'Accounts Checked', value: '153K', subtext: 'Valid: 87,293', subtextColor: 'text-accent-blue' },
    { label: 'Active Users', value: '2,845', subtext: 'Premium: 1,742', subtextColor: 'text-accent-purple' },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-8">
      {stats.map((stat, index) => (
        <div key={index} className="bg-dark-600 rounded-2xl p-5">
          <h4 className="text-gray-400 text-sm mb-2">{stat.label}</h4>
          <p className="text-3xl font-bold">{stat.value}</p>
          <div className="flex items-center mt-1">
            <span className={`text-xs ${stat.subtextColor}`}>{stat.subtext}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ServiceStats;